import React from "react";
import { Link, withRouter, Route } from "react-router-dom";
import { Button, Card, CardBody, CardImg, CardSubtitle, CardText } from "reactstrap";
import BookAppointment from "../../containers/BookAppointment";

class BasicCard extends React.Component {

  componentDidMount() {
    // const height = ;
    // console.log("height", height);
  }

  render() {
    const {
      image,
      title,
      subTitle,
      description,
      btnText,
      match,
      bookNowClicked,
      locationId,
      businessId,
      business_slug
    } = this.props;


    // document.getElementsByClassName('box')[0].clientWidth
		// console.log("TCL: BasicCard -> render -> document.getElementsByClassName('box')[0].clientWidth", document.getElementsByClassName('box')[0].clientWidth)
    let test=false;
    if(description.length > 100) {
      test = true;
    }
    return (
      // <div>
      <div className="col-sm-6 col-md-5 col-lg-4 item">
        {/* <Card className="overflow-hidden">
          <Link to={{ pathname: (business_slug) }}>
            <CardImg top width="100%" src={image} alt="Card image cap" />
            <div className="carousel-caption">
              <h4>{title}</h4>
            </div>
          </Link>
        </Card>
        <div className="button-style">
          <Link to={{ pathname: `${business_slug}/book-appointment` }}>
            <Button
              onClick={() => {
                bookNowClicked(locationId, businessId);
              }}
              className="jr-btn"
            >
              {btnText}
            </Button>
          </Link>
        </div> */}
        <div className="box">
          <Link to={{ pathname: (business_slug) }}>
            <img className="img-fluid homepage-salon-pic" src={image!=''? image : 'https://via.placeholder.com/150x150'} />
          </Link>
          <h3 className="name">{title}</h3>
          <p className="description">{test ? <span>{description.slice(0, 100)} <Link to={{ pathname: (business_slug) }} style={{marginTop: '-14px', marginBottom: '10px', cursor: 'pointer'}}>more...</Link></span>: description}</p>
          
          <Link className="learn-more" to={{ pathname: `${business_slug}/book-appointment` }}>Book Now</Link>
        </div>
      </div>
    );

  }
}

export default withRouter(BasicCard);




// WEBPACK FOOTER //
// ./components/basicCards/BasicCard.js